module.exports = __webpack_public_path__ + "static/media/21ECLAC27.b513fdf6.jpg";